import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HomeAbout } from '../components/HomeAbout';
import { HomeServices } from '../components/HomeServices';
import { HowToBook } from '../components/HowToBook';
import { IGSlider } from '../components/IGSlider';
import { FAQSection } from '../components/FAQSection';
import { ContactSection } from '../components/ContactSection';
import { ReviewCTA } from '../components/ReviewCTA';
import { SocialPromo } from '../components/SocialPromo';
import { PromoOffers } from '../components/PromoOffers';
import { InstagramVideos } from '../components/InstagramVideos';
export function HomePage() {
  return <div className="bg-cream" data-id="element-539">
      <HeroSection data-id="element-540" />
      <PromoOffers data-id="element-541" />
      <HomeAbout data-id="element-542" />
      <HomeServices data-id="element-543" />
      <InstagramVideos data-id="element-544" />
      <HowToBook data-id="element-545" />
      <SocialPromo data-id="element-546" />
      <ReviewCTA data-id="element-547" />
      <FAQSection data-id="element-548" />
      <ContactSection data-id="element-549" />
    </div>;
}